import { MultiAtlasScalingVariantData } from "../../types/types";
import { AppSettings } from "../managers/AppSettings";

export const AppTimings = {
    // generic
    genericShowDuration: 1000,
    genericHideDuration: 1000,
    // specific
    // screenShowDuration: 500,
    // screenHideDuration: 500,
    screenShowDuration: 1000,
    screenHideDuration: 1000,
    hintBubbleShowDuration: 500,
    hintBubbleHideDuration: 500,
    majorDeclarationShowDuration: 500,
    majorDeclarationHideDuration: 500,
    majorDeclarationVisibleDuration: 3000,
    textBubbleDuration: 2000,
    simpleDeclarationDuration: 1000,
    cardFlipNextTaskDelay: 1000,
    cardReorderDuration: 1000,
    preDealTableToPlayerDelay: 1000,
    cardDealTableToPlayerDuration: 300,
    cardDealTableToPlayerDelay: 70,
    trickCollectDuration: 500,
    trickCollectItemDelay: 80,
    cardDealPlayerToTableDuration: 300,
    /**
     * This is AFTER card is deals on table. 
     * For all 4 players, even autoPlay.
     */
    cardDealPlayerToTableDelay: 1000,
    cardDealCardNudgeDuration: 200,
    cardFlipDuration: 400,
    preTrickCollectDelay: 500,
    postTrickCollectDelay: 500,
    cardHighlightDuration: 500,
    /**
     * Pause before leaving table and showing deal complete screen
     */
    preDealCompleteScreenDelay: 1000,
    scrollableContentScrollDuration: 600,
}

export const AppFontsConfig = {
    DealCompleteListItemLabel: {
        fontFamily: AppSettings.fontFamilies.MontserratBold,
        fontSize: "30px",
        metrics: AppSettings.metrics.montserratBold30,
    },
    // DealCompleteHeaderItemLabel: {
    //     fontFamily: AppSettings.fontFamilies.MontserratBold,
    //     fontSize: "36px",
    //     metrics: AppSettings.metrics.montserratBold36,
    // },
    DealCompleteHeaderItemLabel: {
        fontFamily: AppSettings.fontFamilies.MontserratBold,
        fontSize: "30px",
        metrics: AppSettings.metrics.montserratBold30,
    }
}

export const UIVariantsData: Array<MultiAtlasScalingVariantData> = [
    {
        scale: 1,
        atlasURL: "./atlas/ui-s100.json",
        path: "./atlas/"
    },
    {
        scale: 0.75,
        atlasURL: "./atlas/ui-s75.json",
        path: "./atlas/"
    },
    {
        scale: 0.5,
        atlasURL: "./atlas/ui-s50.json",
        path: "./atlas/"
    }
];

export const LobbyVariantsData: Array<MultiAtlasScalingVariantData> = [
    {
        scale: 1,
        atlasURL: "./atlas/lobby-s100.json",
        path: "./atlas/"
    },
    {
        scale: 0.75,
        atlasURL: "./atlas/lobby-s75.json",
        path: "./atlas/"
    },
    {
        scale: 0.5,
        atlasURL: "./atlas/lobby-s50.json",
        path: "./atlas/"
    }
];

export const AvatarsVariantsData: Array<MultiAtlasScalingVariantData> = [
    {
        scale: 1,
        atlasURL: "./atlas/avatars-s100.json",
        path: "./atlas/"
    },
    {
        scale: 0.75,
        atlasURL: "./atlas/avatars-s75.json",
        path: "./atlas/"
    },
    {
        scale: 0.5,
        atlasURL: "./atlas/avatars-s50.json",
        path: "./atlas/"
    }
];

export const ThemesVariantsData: Array<MultiAtlasScalingVariantData> = [
    {
        scale: 1,
        atlasURL: "./atlas/themes-s100.json",
        path: "./atlas/"
    },
    {
        scale: 0.75,
        atlasURL: "./atlas/themes-s75.json",
        path: "./atlas/"
    },
    {
        scale: 0.5,
        atlasURL: "./atlas/themes-s50.json",
        path: "./atlas/"
    }
];